import { reactive, toRefs } from 'vue';
import { v4 as uuidv4 } from 'uuid';

export interface Alert {
  title: string;
  text: string;
}

const state = reactive<{ alerts: (Alert & { id: string })[] }>({
  alerts: [],
});

const showAlert = (props: Alert) => {
  const alert = {
    ...props,
    id: uuidv4(),
  };

  state.alerts = [...state.alerts, alert];
};

const closeAlert = () => {
  state.alerts = state.alerts.slice(0, -1);
};

export default () => ({
  ...toRefs(state),
  showAlert,
  closeAlert,
});
